// extracted by mini-css-extract-plugin
export default {"dropzone":"Dropzone_dropzone__x-+SB","disabledDropzone":"Dropzone_disabledDropzone__sS+A0"};